import { z } from "zod";

const DataResponseSchema = z.object({
    id: z.number(),
    name: z.string(),
    display_name: z.nullable(z.string()),
    group: z.nullable(z.string()),
    guard_name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
});

export const PermissionCreateResponse = z.object({
    code: z.number(),
    data: DataResponseSchema,
    message: z.string(),
    success: z.boolean(),
});

export type PermissionCreateResponse = z.infer<typeof PermissionCreateResponse>;
export type PermissionCreateData = z.infer<typeof DataResponseSchema>;